<template>
    <div class="garanties-filter">
        <div class="garanties-filter--wrap">


            <div class="garanties-filter__fields">

                <div class="garanties-filter__fields--block">
                    <div class="garanties-filter__fields--item field-wrap--amount">
                       <label class="label">
                        <span class="font-regular label--title ">Numéro de contrat</span>
                        <div class="label__input-wrap">
                          <input type="text" v-model="quote_number">
                        </div>
                      </label>
                      <label class="label">
                            <span class="font-regular label--title ">Immatriculation</span>
                            <div class="label__input-wrap">
                                <input type="text" v-model="registration">
                            </div>
                        </label>
                        <label class="label">
                            <span class="font-regular label--title ">Nom du client</span>
                            <div class="label__input-wrap">
                                <input type="text" v-model="full_name">
                            </div>
                        </label>
                    </div>

                    <div class="garanties-filter__fields--item field-wrap--date">
                        <div class="label currency-datepicker">
                                            <span class="label--title">
                                                Date
                                                <span v-if="dateRangeFilled" class="label--reset"
                                                      @click="cleareDateRange">X</span>
                                            </span>
                            <div class="label__input-wrap">
                                <datepicker placeholder="De"
                                            format="DD/MM/YYYY"
                                            :monday-first="true"
                                            :full-month-name="true"
                                            wrapper-class="currency-datepicker__wrapper-low-margin"
                                            input-class="currency-datepicker__input"
                                            calendar-class="currency-datepicker__element"
                                            v-model="selectedDate.startDate"
                                            :highlighted="selectedDate.startDate ? '' : highlightedConfig">
                                </datepicker>
                            </div>
                            <div class="label__input-wrap">
                                <datepicker placeholder="à"
                                            format="DD/MM/YYYY"
                                            :monday-first="true"
                                            :full-month-name="true"
                                            wrapper-class="currency-datepicker__wrapper-low-margin"
                                            input-class="currency-datepicker__input"
                                            calendar-class="currency-datepicker__element"
                                            v-model="selectedDate.endDate"
                                            :highlighted="selectedDate.endDate ? '' : highlightedConfig">
                                </datepicker>
                            </div>
                        </div>
                    </div>
<!--                  #3229 - Garanties souscrites - Multiple choice to remove-->
<!--                    <div class="garanties-filter__fields&#45;&#45;item field-wrap&#45;&#45;garanty">-->
<!--                        <div class="checkboxes-wrap">-->
<!--                            <div class="label-title">Garanties</div>-->

<!--                            <div class="checkboxes-wrap&#45;&#45;item">-->
<!--                                <label class="checkboxes__element">-->
<!--                                    <input type="checkbox" class="checkboxes__element&#45;&#45;input"-->
<!--                                           v-model="garanties.auto.check"/>-->
<!--                                    <span class="checkboxes__element&#45;&#45;text">Auto</span>-->
<!--                                </label>-->
<!--                            </div>-->
<!--                            <div class="checkboxes-wrap&#45;&#45;item">-->
<!--                                <label class="checkboxes__element">-->
<!--                                    <input type="checkbox" class="checkboxes__element&#45;&#45;input"-->
<!--                                           v-model="garanties.moto.check"/>-->
<!--                                    <span class="checkboxes__element&#45;&#45;text">Moto</span>-->
<!--                                </label>-->
<!--                            </div>-->
<!--                            <div class="checkboxes-wrap&#45;&#45;item">-->
<!--                                <label class="checkboxes__element">-->
<!--                                    <input type="checkbox" class="checkboxes__element&#45;&#45;input"-->
<!--                                           v-model="garanties.campingCar.check"/>-->
<!--                                    <span class="checkboxes__element&#45;&#45;text">Camping car</span>-->
<!--                                </label>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>

                <div class="garanties-filter__buttons">
                    <button class="garanties-filter__buttons--button" @click="submitSearch">Rechercher</button>
                </div>

              </div>

            </div>
            <div class="custom-filter__buttons stats" style="align-items: center; display: flex; justify-content: end; margin-right: 30px;" v-if="!isGarden">
              <div><button class="custom-filter custom-icon icon-csv" @click="downloadCSV"></button></div>
              <div><button class="custom-filter custom-icon icon-xlsx" @click="downloadXLSX"></button></div>
            </div>
    </div>
</template>

<script>
    import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker'

    export default {
        name: 'GarantiesFilter',
        components: {
            Datepicker
        },
        data() {
            return {
                quote_number: '',
                registration: '',
                full_name: '',
                garanties: {
                    campingCar: {id:1, check:false},
                    auto: {id:2, check:false},
                    moto: {id:3, check:false},
                },
                dateRangeParams: {
                    today: {
                        type: 'today',
                        startDate: this.moment(new Date()).startOf('day'),
                        endDate: this.moment(new Date())
                    },
                    yesterday: {
                        type: 'yesterday',
                        startDate: this.moment(new Date()).add(-1, 'days').startOf('day'),
                        endDate: this.moment(new Date()).add(-1, 'days').endOf('day')
                    },
                    thisWeek: {
                        type: 'thisWeek',
                        startDate: this.moment(new Date()).startOf('isoWeek').startOf('day'),
                        endDate: this.moment(new Date())
                    },
                    thisMonth: {
                        type: 'thisMonth',
                        startDate: this.moment(new Date()).startOf('month'),
                        endDate: this.moment(new Date())
                    }
                },

                selectedDate: {
                    type: null,
                    startDate: null,
                    endDate: null,
                },
                highlightedConfig: {
                    dates: [new Date()],
                },
            }
        },
        computed: {
            dateRangeFilled() {
                if (this.selectedDate.startDate || this.selectedDate.endDate) {
                    return true;
                }
                return false
            },
            filterParams() {
                let data = {};
                data.pdf = 1;
              if (this.quote_number) {
                data.quote_number = this.quote_number
              }
              if (this.registration) {
                    data.registration = this.registration
                }
                if (this.full_name) {
                    data.full_name = this.full_name
                }

                let categories = [];
                for (let category in this.garanties) {
                    if (this.garanties[category].check) {
                        categories.push(this.garanties[category].id)
                    }
                }
                if (categories.length > 0) {
                    data.categories = categories;
                }


                if (this.dateRangeFilled) {
                    if (this.selectedDate.startDate) data.start_date = this.moment(this.selectedDate.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
                    if (this.selectedDate.endDate) data.end_date = this.moment(this.selectedDate.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
                }
                return data;
            },
        },
        watch: {
            'selectedDate.startDate': function () {
                this.checkDate();
            },
            'selectedDate.endDate': function () {
                this.checkDate();
            },
        },
        methods: {
            checkDate() {
                let type = null;
                for (let key in this.dateRangeParams) {
                    let date = this.dateRangeParams[key];
                    if (date.startDate.format('DD/MM/YYYY') === this.moment(this.selectedDate.startDate).format('DD/MM/YYYY')
                        && date.endDate.format('DD/MM/YYYY') === this.moment(this.selectedDate.endDate).format('DD/MM/YYYY')) {
                        type = date.type;
                    }
                }
                this.selectedDate.type = type;
            },
            selectDate(selectedDate) {
                this.$set(this.selectedDate, 'startDate', selectedDate.startDate.toDate());
                this.$set(this.selectedDate, 'endDate', selectedDate.endDate.toDate());
            },

            cleareDateRange() {
                this.$set(this.selectedDate, 'startDate', null);
                this.$set(this.selectedDate, 'endDate', null);
                this.$set(this.selectedDate, 'type', null);
            },
            submitSearch() {
                if(this.filterParams.end_date || this.filterParams.start_date){
                    this.$parent.filterDefault ? this.$parent.filterDefault = false : '';
                }
                this.$emit('submit', this.filterParams);
            },
            downloadCSV () {
              this.$emit('assistanceDownloadCSV');
            },
            downloadXLSX () {
              this.$emit('assistanceDownloadXLSX');
            },
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/GarantiesSouscrites/AssistancesFilter.vue